import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ArrowForwardIosIcon(props: IconProps) {
    return <Icon {...props} iconKey={"arrow_forward_ios"}/>
}
